<template>
  <div id="dd_warp"></div>
</template>
<script>
export default {
  data() {
    return {
      qrcode: "",
    };
  },
  computed: {},
  methods: {
    /**
     * https://oapi.dingtalk.com/connect/qrconnect
     * ?appid=dingoamhsl6gz5idrcdymn
     * &response_type=code
     * &scope=snsapi_login
     * &state=STATE
     * &redirect_uri=https%3A%2F%2Fsit-newsso.homeinns.com%2FAccountLogin%2FWxBack
     *
     * */
    // 切换钉钉扫码
    changeDingCode: function () {
      const vm = this;
      const ddAppId = "dingoahzsvkbaef2gq6dyu";
      const ddState = vm.state;
      const ddRedirectUrl =
        "https://newsso.bthhotels.com/AccountLogin/WxBack";

      vm.$nextTick(() => {
        this.qrcode = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${ddAppId}&response_type=code&scope=snsapi_login&state=${ddState}_dd&redirect_uri=${ddRedirectUrl}`;
        const obj = window.DDLogin({
          id: "dd_warp", // 这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
          goto: encodeURIComponent(vm.qrcode), // goto参数urlencode编码
          style: "border:none;background-color:#FFFFFF;",
          width: "300",
          height: "400",
        });
        const hanndleMessage = function (event) {
          const origin = event.origin;
          // 判断是否来自ddLogin扫码事件
          if (origin === "https://login.dingtalk.com") {
            const loginTmpCode = event.data;
            // 这里url不用进行urlencode编码
            if (loginTmpCode) {
              const url = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${ddAppId}&response_type=code&scope=snsapi_login&state=${ddState}_dd&redirect_uri=${ddRedirectUrl}&loginTmpCode=${loginTmpCode}`;
              window.location.href = url;
            }
          }
        };
        if (typeof window.addEventListener !== "undefined") {
          window.addEventListener("message", hanndleMessage, false);
        } else if (typeof window.attachEvent !== "undefined") {
          window.attachEvent("onmessage", hanndleMessage);
        }
      });
    },
  },
  mounted() {
    const vm = this;
    vm.$nextTick(function () {
      vm.changeDingCode();
    });
  },
  props: {
    state: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@css/style.scss";
[v-cloak] {
  display: none;
}
</style>
